define(function (require) {
  var cloud = require("cloud/base/cloud");
  var locale = require("cloud/base/locale");
  require("./captcha.css");

  return Class.create(cloud.Component, {

    initialize: function ($super, options) {
      cloud.util.defaults(options, {
        moduleName: "captcha",
      });
      $super(options);
      this.render();
    },

    render: function () {
      this.img = $("<img lang='title:click_to_change'>")
        .attr("title", locale.get('click_to_change'))
        .click(this.refresh.bind(this));

      this.element.append(this.img).addClass("cloud-captcha");
      this.refresh();
    },

    refresh: function () {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      window.Model.captchas({
        method: "get",
        token: false,
        success: function (data) {
          var imgUrl = "/api/captchas/" + data._id + "?r=" + Math.random();
          this.pictureId = data.pictureId;
          this.img.attr("src", imgUrl).attr("picid", data.pictureId);
          this.timer = setTimeout(this.refresh.bind(this), 300000);
        }.bind(this)
      })
    },

    getPicId: function () {
      return this.pictureId;
    }


  });
});



//////////////////
// WEBPACK FOOTER
// ./cloud/components/captcha.js
// module id = 83
// module chunks = 0